import { Component, Input, Output, ViewChild, ViewContainerRef, EventEmitter, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared-component-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @deprecated
 *
 * \@description
 * This Component supports rendering shared component written in latest version of Angular only and it is there for backward compatiblity.
 * It has been depricated now by platform team. Newer version of this component is fxp-shared-component-loader.component
 * which supports rendering shared components written in angular or react.
 */
var SharedComponentLoader = /** @class */ (function () {
    function SharedComponentLoader() {
        this.componentOutput = new EventEmitter();
        this.partnerAppRegistrationService = window["Fxp"].Services.PartnerAppRegistrationService;
        this.fxpAppSettings = window["FxpAppSettings"];
        console.warn('This component is Deprecated now. Please migrate to FxpSharedComponentControl. For more information please check the FxP Docs: https://aka.ms/fxpdocs', "font-size:15px");
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    SharedComponentLoader.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.updateInputParameters();
    };
    /**
     * @return {?}
     */
    SharedComponentLoader.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.childComponent.clear();
        this.childCompRef = null;
    };
    /**
     * @return {?}
     */
    SharedComponentLoader.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var self = this;
        self.childComponent.clear();
        if (self.feedbackEnabled) {
            self.partnerAppRegistrationService
                .getSharedComponentFactory(self.fxpAppSettings.FeedbackControlPartnerName, self.fxpAppSettings.FeedbackControlComponentName).
                then((/**
             * @param {?} feedbackFactory
             * @return {?}
             */
            function (feedbackFactory) {
                self.feedbackCompRef = self.feedbackComponent.createComponent(feedbackFactory);
                self.updateFeedbackParameters();
            }));
        }
        self.partnerAppRegistrationService
            .getSharedComponentFactory(self.appName, self.componentName).
            then((/**
         * @param {?} factory
         * @return {?}
         */
        function (factory) {
            self.childCompRef = self.childComponent.createComponent(factory);
            self.subscribeOuputParameterEvents();
            self.updateInputParameters();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    SharedComponentLoader.prototype.updateInputParameters = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.childCompRef)
            return;
        if (this.componentInputs) {
            /** @type {?} */
            var inputs = this.componentInputs;
            inputs.forEach((/**
             * @param {?} inp
             * @return {?}
             */
            function (inp) {
                _this.childCompRef.instance[inp.key] = inp.value;
            }));
        }
    };
    /**
     * @private
     * @return {?}
     */
    SharedComponentLoader.prototype.updateFeedbackParameters = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.feedbackCompRef)
            return;
        if (this.feedbackSurveyId) {
            this.feedbackCompRef.instance['surveyID'] = this.feedbackSurveyId;
            this.feedbackCompRef.instance['sourceComponentName'] = this.componentName;
            this.feedbackCompRef.instance['sourceAppName'] = this.appName;
        }
    };
    /**
     * @private
     * @return {?}
     */
    SharedComponentLoader.prototype.subscribeOuputParameterEvents = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.childCompRef)
            return;
        if (this.componentOutputKeys) {
            /** @type {?} */
            var outputs = this.componentOutputKeys;
            outputs.forEach((/**
             * @param {?} output
             * @return {?}
             */
            function (output) {
                _this.childCompRef.instance[output.key].subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.componentOutput.emit(data);
                }));
            }));
        }
    };
    SharedComponentLoader.decorators = [
        { type: Component, args: [{
                    selector: 'shared-component-control',
                    template: "<template #feedbackComponent></template><template #partnerSharedComponent></template>"
                }] }
    ];
    /** @nocollapse */
    SharedComponentLoader.ctorParameters = function () { return []; };
    SharedComponentLoader.propDecorators = {
        appName: [{ type: Input }],
        componentName: [{ type: Input }],
        feedbackEnabled: [{ type: Input }],
        feedbackSurveyId: [{ type: Input }],
        componentInputs: [{ type: Input }],
        componentOutputKeys: [{ type: Input }],
        componentOutput: [{ type: Output }],
        childComponent: [{ type: ViewChild, args: ['partnerSharedComponent', { read: ViewContainerRef, static: false },] }],
        feedbackComponent: [{ type: ViewChild, args: ['feedbackComponent', { read: ViewContainerRef, static: false },] }]
    };
    return SharedComponentLoader;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared-component-loader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SharedComponentsModule = /** @class */ (function () {
    function SharedComponentsModule() {
    }
    SharedComponentsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SharedComponentLoader],
                    imports: [],
                    exports: [SharedComponentLoader],
                    entryComponents: [SharedComponentLoader]
                },] }
    ];
    return SharedComponentsModule;
}());

export { SharedComponentLoader, SharedComponentsModule };
//# sourceMappingURL=fxp-angularcontrols.js.map
